<template>
    <b-row>
        <b-col cols="12">
            <TitleComponent title="1. Selecciona tu asiento" subtitle="Si lo deseas, también puedes escoger varios asientos a la vez"></TitleComponent>
        </b-col>
        <b-col cols="12">
            <TerrenoJuegoComponent :direccion_campo="zona.direccion_campo"/>
        </b-col>
        <b-col cols="12">
            <div class="container-butacas-wrapper" v-if="filas">
                <div :class="'container-butacas text-align-' + zona.print_align">
                    <span v-for="(butacas, fila) in filas" :key="fila">
                        <span class="fila">{{ fila }}</span>
                        <AsientoComponent v-for="(asiento, index) in butacas" :asiento="asiento" :fila="fila" :key="index+'_2'" @toggle="() => toggleSeleccion(fila, asiento.asiento, asiento)" />
                        <br />
                    </span>
                </div>
            </div>
            <template v-else>
                <LoaderComponent></LoaderComponent>
            </template>
        </b-col>
    </b-row>
</template>

<script>
import TitleComponent from '@/components/backend/stepper/components/TitleComponent';
import TerrenoJuegoComponent from '../../../common/Asientos/TerrenoJuegoComponent.vue';
import AsientoComponent from "./AsientoComponent";

export default {
    props: {
        zona: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            filas: null
        }
    },
    created() {
        this.getZona(this.zona.id);
    },
    methods: {
        getZona(id) {
            var params = {
                filters: {
                    zona_id: id,
                    conf: true,
                    info: true,
                    evento_id: this.$route.params.evento_id,
                    sesion_id: this.$route.params.sesion_id
                },
            };

            this.$store.dispatch(this.config.getVuexAlias('zonas.index'), params).then(res => {
                this.filas = res.data.configuracion_asientos;
            });
        },
        toggleSeleccion(fila, asiento, status) {
            if(status.info && status.info.tipo == "BLOQUEADO" && status.info.reserva_id == null) {
                if(status.seleccionado) {
                    status.seleccionado = false;
                    this.$emit('deleteSeat', fila, asiento);
                } else {
                    status.seleccionado = true;
                    this.$emit('addSeat', fila, asiento, status);
                }
            } else {
                this.$toast.error('Asiento no disponible.')
            }
        }
    },
    components: {
        TitleComponent, TerrenoJuegoComponent, AsientoComponent
    }
}
</script>